const API_BASE_URL =
process.env.REACT_APP_API_BASE_URL ||
"http://localhost:8000";


const getAuthHeaders = () => {

const token =
localStorage.getItem("token");

if(!token){

throw new Error(
"Authorization token not found"
);

}

return{
"Content-Type":"application/json",
Authorization:`Bearer ${token}`,
};

};


const handleUnauthorized = () => {

localStorage.removeItem("token");
localStorage.removeItem("refresh");
localStorage.removeItem("user");

window.location.href="/";

};


export const getMessageTemplates = async () => {

try{

const response = await fetch(
`${API_BASE_URL}/api/msg_templates/`,
{
method:"GET",
headers:getAuthHeaders(),
}
);

if(response.status===401){

handleUnauthorized();

throw new Error(
"Session expired"
);

}

if(!response.ok){

throw new Error(
"Failed to fetch templates"
);

}

return await response.json();

}catch(error){

console.error(error);

throw error;
}

};



export const getDesignTemplates =
async(templateId)=>{

try{

const response = await fetch(
`${API_BASE_URL}/api/design_templates/${templateId}/`,
{
method:"GET",
headers:getAuthHeaders(),
}
);

if(response.status===401){

handleUnauthorized();

throw new Error(
"Session expired"
);

}

if(!response.ok){

throw new Error(
"Failed to fetch design templates"
);

}

return await response.json();

}catch(error){

console.error(error);

throw error;
}

};